const fourToFive = [
  'Buttons up (4.2 yr)',
  'Copies square (4.4 yr)',
  'Recognizes 3 colors',
  'Throws ball',
  'Hops on 1 foot (4.9 yr)',
  'Draws man',
  'Follows 3 commands',
  'Fully potty trained',
  'Speech understandable',
];

const sixToEight = [
  'School progress',
  'Grade',
  'Names three animals',
  'Sports',
  'Peer relationship',
  'Hobbies',
  'Rides bicycle',
];

const nineToTwelve = [
  'School progress',
  'Grade',
  'Sports',
  'Peer relationship',
  'Hobbies',
];

const thirtheenToSixteen = [
  'Sets goals and works towards achieving them',
  'Takes on new responsibility',
  'Maintains peer relationships',
  'Sports',
  'Improved social skills',
  'Maintains family relationships',
];

const seventeenToTwenty = [
  'Acts responsibly for self',
  'Maintains school achievement',
  'Maintains family relationships',
  'Improved social skills',
  'Exhibits capacity for empathy, reciprocity in interpersonal relationships',
  'Job/Future plans',
  'Takes on new responsibilities',
];

module.exports = {
  // one month
  0: [
    'Prone lifts head',
    'Responds to noise',
    'Follows to midline',
    'Regards face',
    'Turns head side to side',
  ],
  // two months
  1: [
    'Vocalizes',
    'Smiles responsively',
    'Kicks',
    'Lifts head 45°',
    'Follows past midline',
  ],
  // four months
  2: [
    'Prone lifts head 90°',
    'Laughs/squeals',
    'Follows to 180°',
    'Head steady sitting',
    'Grasps rattle',
    'Rolls over one way',
  ],
  // 6 months
  3: [
    'Pulled to sit - no head lag',
    'Reaches for object',
    'Smiles spontaneously',
    'Rolls over both ways',
    'Sits briefly alone',
    'Gums objects',
    'Babbles',
    'Turns to sound',
  ],
  // 9 months
  4: [
    'Sits without support',
    'Feeds self cracker',
    'Transfers object from one hand to another',
    'Turns to voice',
    'Bangs object',
    'Creeps and crawls',
  ],
  // 12 months
  5: [
    'Stands momentarily',
    'Walks holding furniture',
    'Bangs object',
    '"Mama", "Dada" (now specific)',
    'Thumb-finger grasp',
    'Holds cup to drink',
    'Looks for falling object',
    'Waves bye-bye, understands No',
  ],
  // 18 months
  6: [
    'Mimics household chores',
    'Walks well - climbs',
    '4-10 word vocabulary',
    'Scribbles',
  ],
  // 2 years
  7: [
    'Kicks ball',
    'Points to body part',
    'Simple household tasks',
    'Walks up and down stairs',
    'Handles spoon well',
    'Runs well',
    'Follows simple directions',
  ],
  // 3 years
  8: [
    'Knows name, age, sex',
    'Short sentences, speech understood by family, plurals',
    'Helps dress self/washes hands',
    'Rides tricycle',
    'Climbs stairs, alternating feet',
    'Knows one color',
  ],
  // 4 years
  9: fourToFive,
  // 5 years
  10: fourToFive,
  // 6 years
  11: sixToEight,
  // 7 years
  12: sixToEight,
  // 8 years
  13: sixToEight,
  // 9 years
  14: nineToTwelve,
  // 10 years
  15: nineToTwelve,
  // 11 years
  16: nineToTwelve,
  // 12 years
  17: nineToTwelve,
  // 13 years
  18: thirtheenToSixteen,
  // 14 years
  19: thirtheenToSixteen,
  // 15 years
  20: thirtheenToSixteen,
  // 16 years
  21: thirtheenToSixteen,
  // 17 years
  22: seventeenToTwenty,
  // 18 years
  23: seventeenToTwenty,
  // 19 years
  24: seventeenToTwenty,
  // 20 years
  25: seventeenToTwenty,
};



// WEBPACK FOOTER //
// ./client/src/components/patientPages/wellChildCheck/developmentItems.js